import { gql } from '@apollo/client'

import { GROUP_FRAGMENT } from '../fragments'

export const CREATE_DAI_GROUP = gql`
  mutation CreateDaiGroup($data: CreateDaiGroupInput!) {
    createDaiGroup(data: $data) {
      ...Group
    }
  }
  ${GROUP_FRAGMENT}
`
